import { render, staticRenderFns } from "./DatatableButtonsObjeto.vue?vue&type=template&id=0ed47cbe"
import script from "./DatatableButtonsObjeto.vue?vue&type=script&lang=js"
export * from "./DatatableButtonsObjeto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports